import { Router } from '@angular/router';
import { Settings } from '../../../core/config/settings.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config/settings.service";
import * as i2 from "@angular/router";
var BillingEnabledGuard = /** @class */ (function () {
    function BillingEnabledGuard(settings, router) {
        this.settings = settings;
        this.router = router;
    }
    BillingEnabledGuard.prototype.canActivate = function (route, state) {
        return this.handle();
    };
    BillingEnabledGuard.prototype.canActivateChild = function (route, state) {
        return this.handle();
    };
    BillingEnabledGuard.prototype.handle = function () {
        if (this.settings.get('billing.integrated') && this.settings.get('billing.enable')) {
            return true;
        }
        this.router.navigate(['/drive']);
        return false;
    };
    BillingEnabledGuard.ngInjectableDef = i0.defineInjectable({ factory: function BillingEnabledGuard_Factory() { return new BillingEnabledGuard(i0.inject(i1.Settings), i0.inject(i2.Router)); }, token: BillingEnabledGuard, providedIn: "root" });
    return BillingEnabledGuard;
}());
export { BillingEnabledGuard };
